
import { defineComponent, PropType } from 'vue'
import { provideDiscountDuplicateForm } from '../application/composables/provideDiscountDuplicateForm'
import PBackButton from '../application/components/presenters/PBackButton.vue'
import CDiscountForm from '../application/components/CDiscountForm.vue'
import { DiscountPolicy } from '../domain/DiscountPolicy'

export default defineComponent({
  name: 'VDuplicateDiscount',
  components: {
    PBackButton,
    CDiscountForm,
  },
  props: {
    discountId: {
      type: String,
      required: true,
    },
    discountPolicyId: {
      type: String as PropType<DiscountPolicy['id']>,
      required: true,
    },
    active: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const discountPolicy = DiscountPolicy.fromId(props.discountPolicyId)
    provideDiscountDuplicateForm(props.discountId, discountPolicy, props.active)
  },
})
